import { MAX_FIELD_LENGTH } from './fieldLimits';

// The reseller forms (views/reSellers): a reseller is a person with a business, so first name, last name and
// company name are all required. The server checks the same (laravel AuthController RESELLER_RULES).

const FIELDS = [
	['first', 'first name'],
	['last', 'last name'],
	['company', 'company name'],
];

// What is wrong with the names typed ({ first, last, company }), or '' when they can be saved.
export function resellerFormProblem(values) {
	for (const [key, label] of FIELDS) {
		const value = values && values[key] != null ? String(values[key]).trim() : '';
		if (value === '') {
			return 'Please enter the ' + label + '.';
		}
		if (value.length > MAX_FIELD_LENGTH) {
			return 'The ' + label + ' must be ' + MAX_FIELD_LENGTH + ' characters or fewer.';
		}
	}
	return '';
}

// The note for an older reseller whose details are not complete (missing, from the server: a list of
// 'last name' and 'company name'), or '' when nothing is missing.
export function resellerMissingNotice(missing) {
	if (!Array.isArray(missing) || missing.length === 0) {
		return '';
	}
	const what = missing.length === 1 ? 'the ' + missing[0] : 'the ' + missing.slice(0, -1).join(', ') + ' and the ' + missing[missing.length - 1];
	return 'Please fill in ' + what + ' for this reseller, then save.';
}

// The short flag on the Resellers list ("Needs last name and company name"), or ''.
export function resellerMissingFlag(missing) {
	if (!Array.isArray(missing) || missing.length === 0) {
		return '';
	}
	return 'Needs ' + missing.join(' and ');
}
